import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { UserApiService } from '../../shared/services/api/user-api.service';

/**
 * Route guard for the tenant column-mapping admin surface
 * (`/admin/configs/column-mapping`, GF-4206 Phase 3).
 *
 * Reads the caller's DB-granted permissions from `GET /user/auth/me` and
 * activates the route only if `column_mapping.manage` is present. Tenant
 * users — and any super_user without the explicit grant — are bounced to
 * `/home`. Mirrors `uiConfigAdminGuard`.
 */
export const columnMappingAdminGuard: CanActivateFn = async () => {
  const userApi = inject(UserApiService);
  const router = inject(Router);
  try {
    const me = await firstValueFrom(userApi.getUserData());
    if (me.permissions?.includes('column_mapping.manage')) {
      return true;
    }
  } catch {
    // Network / auth issues fall through to redirect — the authTokenInterceptor
    // already handles the 401/403 cases at the HTTP layer.
  }
  return router.createUrlTree(['/home']);
};
